var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('masked-date-input', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 10,
      expression: "10"
    }],
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.form.dateFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dateFrom", $$v);
      },
      expression: "form.dateFrom"
    }
  }), _c('masked-date-input', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 10,
      expression: "10"
    }],
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.form.dateTo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dateTo", $$v);
      },
      expression: "form.dateTo"
    }
  }), _c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:white",
      arg: "white"
    }, {
      name: "cursor",
      rawName: "v-cursor:pointer",
      arg: "pointer"
    }],
    attrs: {
      "name": "basic_lightning"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('show-presets');
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }